// extracted by mini-css-extract-plugin
export var lbContainerOuter = "m_pY";
export var lbContainerInner = "m_pZ";
export var movingForwards = "m_p0";
export var movingForwardsOther = "m_p1";
export var movingBackwards = "m_p2";
export var movingBackwardsOther = "m_p3";
export var lbImage = "m_p4";
export var lbOtherImage = "m_p5";
export var prevButton = "m_p6";
export var nextButton = "m_p7";
export var closing = "m_p8";
export var appear = "m_p9";